import React , { Component, PropTypes } from 'react';
import {Editor, EditorState, RichUtils} from 'draft-js';
import {stateToHTML} from 'draft-js-export-html';
import {stateFromHTML} from 'draft-js-import-html';

import '../node_modules/draft-js/dist/Draft.css';
import './richeditor.css';


     const styles = {
        root: {
          fontFamily: '\'Helvetica\', sans-serif',
          padding: 20,
          width: 600,
        },
        editor: {
          border: '1px solid #ccc',
          cursor: 'text',
          minHeight: 80,
          padding: 10,
        },
        button: {
          marginTop: 10,
          textAlign: 'center',
        },
      };

class MyEditor extends Component {
	constructor(props){
		super(props);
    if (this.props.initContent){
      let contentState = stateFromHTML(this.props.initContent);
      this.state = {editorState: EditorState.createWithContent(contentState)};
    } else {
		  this.state = {editorState: EditorState.createEmpty()};
    }
    this.onChange = (editorState) => this.setState({editorState});
    this.handleKeyCommand = this.handleKeyCommand.bind(this);
    this.toggleBlockType = (type) => this._toggleBlockType(type);
    this.toggleInlineStyle = (style) => this._toggleInlineStyle(style);
    this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleKeyCommand(command) {
    const newState = RichUtils.handleKeyCommand(this.state.editorState, command);
    if (newState) {
      this.onChange(newState);
      return true;
    }
    return false;
  }
  	
	_toggleBlockType(blockType) {
    this.onChange(
      RichUtils.toggleBlockType(
        this.state.editorState,
          blockType
        )
      );
    }

  _toggleInlineStyle(inlineStyle) {
      this.onChange(
        RichUtils.toggleInlineStyle(
    	   this.state.editorState,
        	    inlineStyle
          )
      );
  }
	
  handleSubmit(evt){
  	evt.preventDefault();
    let html = stateToHTML(this.state.editorState.getCurrentContent());
    this.props.handleSubmit(html);
  }

	render(){
		const {editorState} = this.state;
		// If the user changes block type before entering any text, we can
    // either style the placeholder or hide it. Let's just hide it now.
    let className = 'RichEditor-editor';
    var contentState = editorState.getCurrentContent();
    if (!contentState.hasText()) {
      if (contentState.getBlockMap().first().getType() !== 'unstyled') {
        className += ' RichEditor-hidePlaceholder';
      }
    }

		return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <div className="RichEditor-root">
            <BlockStyleControls
                editorState={editorState}
                onToggle={this.toggleBlockType}
            />
            <InlineStyleControls
                editorState={editorState}
                onToggle={this.toggleInlineStyle}
            />
            <div className={className} onClick={this.focus}>
      				<Editor blockStyleFn={getBlockStyle}
                      customStyleMap={styleMap}
                      editorState={editorState}
                      handleKeyCommand={this.handleKeyCommand}
                      onChange={this.onChange}
                      //placeholder="Tell a story..."
                      ref="editor"
                      spellCheck={true}
                      stripPastedStyles={true}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12" style={{'marginTop': 10, 'marginBottom': 10}}>
	          <button className="btn btn-primary" onClick={this.handleSubmit} >Sauver</button>
	          {' '}
	          <button className="btn" onClick={this.props.cancelEditing} >Annuler</button>
        </div>          
      </div>
    </div>
		);
	}
}

// Custom overrides for "code" style.
const styleMap = {
    CODE: {
	    backgroundColor: 'rgba(0, 0, 0, 0.05)',
        fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
        fontSize: 14,
        padding: 2,
    },
};

function getBlockStyle(block) {
	switch (block.getType()) {
    	case 'blockquote': return 'RichEditor-blockquote';
        default: return null;
    }
}

class StyleButton extends React.Component {
	constructor() {
    	super();
        this.onToggle = (e) => {
        	e.preventDefault();
        	this.props.onToggle(this.props.style);
        };
    }

    render() {
    	let className = 'RichEditor-styleButton';
        if (this.props.active) {
        	className += ' RichEditor-activeButton';
        }
        if (this.props.label == 'Citation'){
        	return (
	        	<span className={className} onMouseDown={this.onToggle} title='Citer'>
	            	Citer
	            </span>
        	);
        }
        if (this.props.label == 'Titre'){
        	className += ' glyphicon glyphicon-header';
        	return (
	        	<span className={className} onMouseDown={this.onToggle} title='Titre'>
	            	
	            </span>
        	);
        }
        if (this.props.label == 'Liste'){
        	className += ' glyphicon glyphicon-list';
        	return (
	        	<span className={className} onMouseDown={this.onToggle} title='Liste'>
	            	
	            </span>
        	);
        }
        if (this.props.label == 'Liste Ord.'){
        	className += ' glyphicon glyphicon-list-alt';
        	return (
	        	<span className={className} onMouseDown={this.onToggle} title='Liste ordonnée'>
	            	
	            </span>
        	);
        }
        if (this.props.label == 'Italique'){
        	return (
	        	<span className={className} onMouseDown={this.onToggle} title='Italique'>
	            	<i>I</i>talique
	            </span>
        	);
        }
        if (this.props.label == 'Gras'){
        	return (
	        	<span className={className} onMouseDown={this.onToggle} title='Gras'>
					<b>G</b>ras	            	
	            </span>
        	);
        }
        if (this.props.label == 'Souligner'){
        	return (
	        	<span className={className} onMouseDown={this.onToggle} title='Souligner'>
					<u>S</u>ouligner	            	
	            </span>
        	);
        }

        return (
        	<span className={className} onMouseDown={this.onToggle}>
            	{this.props.label}
            </span>
        );
    }
}

const BLOCK_TYPES = [
  	//{label: 'H1', style: 'header-one'},
    //{label: 'H2', style: 'header-two'},
    {label: 'Titre', style: 'header-three'},
    //{label: 'H4', style: 'header-four'},
    //{label: 'H5', style: 'header-five'},
    //{label: 'H6', style: 'header-six'},
    {label: 'Liste', style: 'unordered-list-item'},
    {label: 'Liste Ord.', style: 'ordered-list-item'},
    {label: 'Citation', style: 'blockquote'},
    //{label: 'Code Block', style: 'code-block'},
];

const BlockStyleControls = (props) => {
	const {editorState} = props;
    const selection = editorState.getSelection();
    const blockType = editorState
          .getCurrentContent()
          .getBlockForKey(selection.getStartKey())
          .getType();

    return (
    	<div className="RichEditor-controls">
        	{BLOCK_TYPES.map((type) =>
	            <StyleButton
	                key={type.label}
	                active={type.style === blockType}
	                label={type.label}
	                onToggle={props.onToggle}
	                style={type.style}
	              />
	            )}
        </div>
    );
};

var INLINE_STYLES = [
	{label: 'Gras', style: 'BOLD'},
	{label: 'Italique', style: 'ITALIC'},
	{label: 'Souligner', style: 'UNDERLINE'}
];

const InlineStyleControls = (props) => {
	var currentStyle = props.editorState.getCurrentInlineStyle();
    return (
    	<div className="RichEditor-controls">
        	{INLINE_STYLES.map(type =>
              <StyleButton
                key={type.label}
                active={currentStyle.has(type.style)}
                label={type.label}
                onToggle={props.onToggle}
                style={type.style}
              />
            )}
        </div>
    );
};


export default MyEditor





// WEBPACK FOOTER //
// ./shared/MyEditor.jsx